<script>
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
  
    import { translator } from "../../store/index";
    import { getOffersOverview } from "../../helpers/apiHelpers/index.svelte";
    import { DataTable, Modal, Button } from "../../components/index.svelte";
    import { toast } from "../../helpers/utils.svelte";
    let dataSource = null;
    let toggler;
    let userToDelete = null;
  
    function getColumns() {
      return [
        { data: "ref_no", title: translator("Ref No") },
        { data: "company_name", title: translator("Alıcı Şirket") },
        { data: "product_count", title: translator("Ürün Sayısı") },
        { data: "total_price_tl", title: translator("Toplam Tutar") },
        { data: "created_at", title: translator("Teklif Tarihi") },
      ];
    }
  
    async function getDataSource() {
      var offers = await getOffersOverview();
      console.log(offers);
      return offers;
    }
  
    function onView(row) {
      console.log(row);
      // navigate(window.location.pathname + '/' + row.id);
    }
  
    function onEdit(row) {
      navigate(window.location.origin + "/offer-management/" + row.id + "/edit");
    }
  
    function onDelete(row) {
      userToDelete = row;
      toggler();
    }
  
    async function onDeleteClick(userID) {
      /* try {
        await deleteUser(userID);
        dataSource = await getDataSource();
        toast.success(
          translator("Başarılı"),
          translator('"__FULLNAME__" Kullanıcısı silindi', {
            __FULLNAME__: `${userToDelete.firstname} ${userToDelete.lastname}`,
          })
        );
        toggler();
      } catch (err) {
        console.log(err);
        toast.error(
          translator("Hata"),
          err.getResponseMessage ? err.getResponseMessage() : err.message
        );
      } */
    }
  
    function onAdd() {
      navigate("/" + window.location.pathname.split('/')[1] + "/new");
    }
  
    onMount(async () => {
      dataSource = await getDataSource();
    });
  </script>
  
  <div class="row">
    <DataTable
      title={translator("Teklif Listesi")}
      eventHandlers={{
        onEdit,
        onDelete,
      }}
      columns={getColumns()}
      onAddClick={onAdd}
      addText={translator("Yeni Teklif Oluştur")}
      bind:dataSource
    />
  </div>
  <Modal
    bind:toggle={toggler}
    title={translator("Dikkat!")}
    onClose={() => {
      userToDelete = null;
    }}
  >
    <div slot="modal-body">
      {translator(
        '"__FULLNAME__" Kullanıcısını kalıcı olarak silmek istediğinize emin misiniz?',
        {
          __FULLNAME__: `${userToDelete.firstname} ${userToDelete.lastname}`,
        }
      )}
    </div>
    <div slot="modal-footer">
      <Button size="sm" onClick={() => onDeleteClick(userToDelete.id)}>
        {translator("Sil")}
      </Button>
      <Button size="sm" onClick={toggler} colorCls="btn-dark">
        {translator("Vazgeç")}
      </Button>
    </div>
  </Modal>
  